import React from "react";
import { useState, useEffect } from "react";
import authStorage from "../service/authStorage";
import { Link, useNavigate } from "react-router-dom";
import {
  UserContext,
  UserContextProvider,
} from "../components/users/UserContext";
import { useContext } from "react";
import ModalCreateNewFolder from "../components/treeModalWindows/ModalCreateNewFolder";
import Node from "../components/Node";
import findSimulationMaxValue from "../service/findSimulationMaxValue";
import setSimulationData from "../service/setSimulationData";
import SimulationResultsDataTable from "../components/SimulationResultsDataTable";
import SimulationChart from "../charts/SimulationChart";
import PropertyPanel from "../components/property/PropertyPanel";
import { useSelector } from "react-redux/es/exports";
import { useDispatch } from "react-redux/es/hooks/useDispatch";
import headerService from "../service/headerService";
import Loader from "../components/loader/Loader";
import { switchViewMode } from "../components/mainPage/switchService";
import LargeButton from "../ui/LargeButton";
import Logo from "../components/mainPage/Logo";
import comparator from "../service/comparator";
import Node2 from "../components/Node2";

const Main = () => {
  const TREE_URL = process.env.REACT_APP_ARI_URL + "/tree";
  const BEARER = authStorage();
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState();
  const [isNeedRefreshAllTree, setIsNeedRefreshAllTree] = useState();
  const user = useContext(UserContext);
  const [creationFolderName, setCreationFolderName] = useState("");
  const CREATE_TEMPLATE_FOLDER_PATH =
    process.env.REACT_APP_ARI_URL + "/tree/templatestree/folders";
  const CREATE_SCENARIO_FOLDER_PATH =
    process.env.REACT_APP_ARI_URL + "/tree/scenariostree/folders";
  const [requestPath, setRequestPath] = useState();
  const [requestDTO, setRequestDTO] = useState();
  const [isShowCreateNewFolderWindow, setIsShowCreateNewFolderWindow] =
    useState();
  const [isNeedRequestNewFolderCreation, setIsNeedRequestNewFolderCreation] =
    useState();
  const CREATE_NEW_FOLDER_IN_ROOT_FOLDER_TITLE =
    "Сreate new folder in 'root' folder";
  const SIMULATE_URL = process.env.REACT_APP_ARI_URL + "/experiment/run";
  const [statistic, setStatistic] = useState([]);
  const [maxChartValue, setMaxChartValue] = useState();
  const [plotData, setPlotData] = useState();
  const [isNeedRefreshScenarios, setIsNeedRefreshScenarios] = useState(false);
  const [isNeedRunSimulate, setIsNeedRunSimulate] = useState();
  const TIMEOUT_SCENARIOS_RELOAD = 1000;

  const [
    onPressEnterCreateModalNewFolder,
    setOnPressEnterCreateModalNewFolder,
  ] = useState(false);

  const scenarioSimulateID = useSelector((state) => state?.scenarioId);
  const templateSimulateID = useSelector((state) => state?.templateId);
  const isNeedRefreshSimulation = useSelector(
    (state) => state?.isNeedRefreshSimulation
  );
  const isChangedCurrentScenario = useSelector(
    (state) => state?.isChangedCurrentScenario
  );
  const updateFolderTreeWithEachIteration = useSelector(
    (state) => state?.updateFolderTreeWithEachIteration
  );
  const simulatedScenarioName = useSelector(
    (state) => state?.simulatedScenarioName
  );

  const isNeedCreateFirstUserFolder = useSelector(
    (state) => state.isNeedCreateFirstUserFolder
  );
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [viewMode, setViewMode] = useState("main-page-fullView");
  const [propertiesEditMode, setPropertiesEditMode] = useState(false);
  const APP_PATH = process.env.REACT_APP_CONTEXT_PATH;

  const [
    isResetChangesAndSaveButtonsDisabled,
    setIsResetChangesAndSaveButtonsDisabled,
  ] = useState(true);
  const isTemplateCurrentScenario = useSelector(
    (state) => state?.isTemplateCurrentScenario
  );
  const isNeedGetScenarioProperties = useSelector(
    (state) => state?.isNeedGetScenarioProperties
  );

  // redirect without auth
  const redirectIfNoAuth = (response) => {
    if (response.status === 401) {
      navigate("/login");
    }
  };

  // get tree
  useEffect(() => {
    // timeout for correct request folders tree
    const timeoutID = window.setTimeout(() => {
      setErrorMsg("");
      const fetchItems = async () => {
        try {
          const response = await fetch(`${TREE_URL}`, {
            headers: headerService(),
          });
          redirectIfNoAuth(response);
          const data = await response.json();
          setItems(data);
          dispatch({
            type: "SET_TREE",
            payload: data,
          });
        } catch (err) {
          setErrorMsg("Server in not responding");
        }
      };
      setIsNeedRefreshAllTree(false);
      fetchItems();
      setViewMode(
        user?.role === "ADMIN" ? "main-page-graphAndTree" : "main-page-fullView"
      );
    }, TIMEOUT_SCENARIOS_RELOAD);
    return () => window.clearTimeout(timeoutID);
  }, [isNeedRefreshAllTree, updateFolderTreeWithEachIteration]);

  // create new folder in root
  useEffect(() => {
    if (!isNeedRequestNewFolderCreation) {
      return;
    }
    setErrorMsg("");
    const fetchItems = async () => {
      try {
        const response = await fetch(`${requestPath}`, {
          method: "POST",
          headers: headerService(),
          body: JSON.stringify(requestDTO),
        });
        if (response.status === 401) {
          navigate("/login");
        }
        const data = await response.json();
        setItems(data);
        setIsNeedRefreshAllTree(true);
      } catch (err) {
        console.log("Server in not responding");
      }
    };
    setIsNeedRequestNewFolderCreation(false);
    setRequestPath();
    setCreationFolderName();
    turnOffFlagCreateFirstUserFolder();
    fetchItems();
  }, [isNeedRequestNewFolderCreation]);

  const handleCreateNewFolder = (event) => {
    event.preventDefault();
    setRequestDTO({
      parentId: null,
      name: creationFolderName,
    });
    setIsNeedRequestNewFolderCreation(true);
    setIsShowCreateNewFolderWindow(false);
  };

  // show create new folder modal
  const handleShowCreateNewFolderWindow = (event, isTemplate) => {
    event.preventDefault();
    setIsShowCreateNewFolderWindow(true);
    if (isTemplate) {
      setRequestPath(CREATE_TEMPLATE_FOLDER_PATH);
    } else {
      setRequestPath(CREATE_SCENARIO_FOLDER_PATH);
    }
  };

  // show create new folder modal,
  // because the user wanted to copy the
  // template about didn't have any folders
  useEffect(() => {
    if (!isNeedCreateFirstUserFolder) {
      return;
    }
    setIsShowCreateNewFolderWindow(true);
    setRequestPath(CREATE_SCENARIO_FOLDER_PATH);
  }, [isNeedCreateFirstUserFolder]);

  // turn off flag to create first user folder
  const turnOffFlagCreateFirstUserFolder = () => {
    dispatch({
      type: "CREATE_FIRST_USER_FOLDER",
      payload: false,
    });
  };

  // hide create new folder modal
  const handleCloseCreateNewFolderWindow = (event) => {
    event.preventDefault();
    setIsShowCreateNewFolderWindow(false);
    setRequestPath();
    setCreationFolderName();
    turnOffFlagCreateFirstUserFolder();
  };

  const handleNewFolderNameCreate = (event) => {
    event.preventDefault();
    setCreationFolderName(event.target.value);
  };

  const cancelRefreshSimulationFlag = () => {
    dispatch({
      type: "IS_NEED_REFRESH_SIMULATION",
      payload: false,
    });
  };

  /// simulation scenario
  useEffect(() => {
    if (scenarioSimulateID || templateSimulateID || isNeedRefreshSimulation) {
      setIsLoading(true);
      const dto = {
        scenarioId: scenarioSimulateID
          ? scenarioSimulateID
          : templateSimulateID,
      };

      const fetchStats = async () => {
        try {
          const response = await fetch(SIMULATE_URL, {
            method: "POST",
            headers: headerService(),
            body: JSON.stringify(dto),
          });
          redirectIfNoAuth(response);
          if (response.status === 400) {
            const msg = await response.text();
            setErrorMsg(msg.substring(10, msg.length - 2));
            return;
          }
          const data = await response.json();
          setStatistic(data);
          setMaxChartValue(findSimulationMaxValue(data));

          setIsLoading(false);  
          setPlotData(setSimulationData(data));

          dispatch({
            type: "GET SCENARIO PROPERTIES",
            payload: false,
          });
          dispatch({
            type: "IS_CHANGED_CURRENT_SCENARIO",
            payload: false,
          });
        } catch (error) {
          console.log(error);
        }
      };
      setIsNeedRefreshScenarios(false);
      fetchStats();
      cancelRefreshSimulationFlag();
    }
  }, [scenarioSimulateID, templateSimulateID, isNeedRefreshSimulation]);

  const handleViewMode = (event) => {
    event.preventDefault();
    setViewMode(switchViewMode(viewMode, event.target.id));
    if (
      (viewMode === "main-page-fullView" ||
        viewMode === "main-page-graphAndProps") &&
      event.target.id === "collapse-props"
    ) {
      setPropertiesEditMode(false);
    }
  };

  const resetChanges = (event) => {
    event.preventDefault();
    setIsResetChangesAndSaveButtonsDisabled(true);
    dispatch({
      type: "GET SCENARIO PROPERTIES",
      payload: true,
    });
  };

  const saveChanges = (event) => {
    event.preventDefault();
    dispatch({
      type: "SEND TO SERVER NEW PROPERTIES",
      payload: true,
    });
  };

  // SIMULATE FROM PROPERTIES
  const simulate = (event) => {
    event.preventDefault();
    if (isTemplateCurrentScenario) {
      dispatch({
        type: "NEW_TEMPLATE_SIMULATED_ID",
        payload: templateSimulateID,
      });
      dispatch({
        type: "NEW_SCENARIO_SIMULATED_ID",
        payload: 0,
      });
      dispatch({ type: "IS_TEMPLATE_CURRENT_SCENARIO", payload: true });
    } else {
      dispatch({
        type: "NEW_SCENARIO_SIMULATED_ID",
        payload: scenarioSimulateID,
      });
      dispatch({
        type: "NEW_TEMPLATE_SIMULATED_ID",
        payload: 0,
      });
      dispatch({ type: "IS_TEMPLATE_CURRENT_SCENARIO", payload: false });
    }
    dispatch({
      type: "IS_NEED_REFRESH_SIMULATION",
      payload: true,
    });
    dispatch({
      type: "IS_CHANGED_CURRENT_SCENARIO",
      payload: false,
    });
    dispatch({
      type: "GET SCENARIO PROPERTIES",
      payload: false,
    });
  };

  useEffect(() => {
    if (isChangedCurrentScenario) {
      setIsResetChangesAndSaveButtonsDisabled(false);
    } else {
      setIsResetChangesAndSaveButtonsDisabled(true);
    }
  }, [isChangedCurrentScenario]);

  // handle press ENTER modal create new folder
  useEffect(() => {
    if (!onPressEnterCreateModalNewFolder) {
      return;
    }
    setRequestDTO({
      parentId: null,
      name: creationFolderName,
    });
    setIsNeedRequestNewFolderCreation(true);
    setIsShowCreateNewFolderWindow(false);
    setOnPressEnterCreateModalNewFolder(false);
  }, [onPressEnterCreateModalNewFolder]);

  useEffect(() => {
    if (!isNeedRefreshSimulation) {
      return;
    }
    setPlotData();
    setIsLoading(true);
  }, [isNeedRefreshSimulation]);

  return (
    <div>
      <div>
        <div className={viewMode}>
          {(viewMode === "main-page-fullView" ||
            viewMode === "main-page-graphAndTree") && (
            <div className="item tree">
              <div className="logo-background">
                <Logo />
              </div>

              <div className="folders-panel">
                {user?.role === "CLIENT" && (
                  <div className="flex justify">
                    <div className="folders-header">
                      <h5 className="not-select-text">MY SCENARIOS</h5>
                    </div>
                    <div className="folders-header-add-folder-button not-select-text">
                      <img
                        onClick={(e) =>
                          handleShowCreateNewFolderWindow(e, false)
                        }
                        alt=""
                        src={`${APP_PATH}/add-folder-icon.svg`}
                        width="21"
                        height="21"
                        className="d-inline-block align-top"
                      />
                    </div>
                  </div>
                )}
                {items?.scenariosTree !== undefined &&
                  user?.role === "CLIENT" &&
                  items?.scenariosTree.length === 0 && (
                    <div>
                      <img
                        alt=""
                        src={`${APP_PATH}/add-folder-icon-light-grey.svg`}
                        width="100"
                        height="100"
                        className="tooltip-user-tree not-select-text opacity"
                      />
                      <p className="tooltip-user-tree not-select-text">
                        Start forming your scenario tree with a{" "}
                        <span
                          className="tooltip-user-tree-link not-select-text"
                          onClick={(e) =>
                            handleShowCreateNewFolderWindow(e, false)
                          }
                        >
                          new folder
                        </span>
                      </p>
                    </div>
                  )}
                <div>
                  <div>
                    {items.scenariosTree?.sort(comparator).map((folder) => (
                      <Node2
                        node={folder}
                        key={folder.id}
                        isNeedRefreshAllTree={isNeedRefreshAllTree}
                        setIsNeedRefreshAllTree={setIsNeedRefreshAllTree}
                      />
                    ))}
                  </div>
                </div>

                <div>
                  <hr></hr>
                </div>

                <div className="flex justify">
                  <div className="folders-header">
                    <h5 className="not-select-text">STANDARD SCENARIOS</h5>
                  </div>
                  {user?.role === "ADMIN" && (
                    <div className="folders-header-add-folder-button not-select-text">
                      <img
                        onClick={(e) =>
                          handleShowCreateNewFolderWindow(e, true)
                        }
                        alt=""
                        src={`${APP_PATH}/add-folder-icon.svg`}
                        width="21"
                        height="21"
                        className="d-inline-block align-top"
                      />
                    </div>
                  )}
                </div>
                {items?.templatesTree !== undefined &&
                  user?.role === "ADMIN" &&
                  items?.templatesTree.length === 0 && (
                    <div>
                      <img
                        alt=""
                        src={`${APP_PATH}/add-folder-icon-light-grey.svg`}
                        width="100"
                        height="100"
                        className="tooltip-user-tree not-select-text opacity"
                      />
                      <p className="tooltip-user-tree not-select-text">
                        Start forming the tree of standard scenarios with a{" "}
                        <span
                          className="tooltip-user-tree-link not-select-text"
                          onClick={(e) =>
                            handleShowCreateNewFolderWindow(e, true)
                          }
                        >
                          new folder
                        </span>
                      </p>
                    </div>
                  )}

                {items?.templatesTree !== undefined &&
                  user?.role === "CLIENT" &&
                  items?.templatesTree.length === 0 && (
                    <div>
                      <img
                        alt=""
                        src={`${APP_PATH}/no-items-icon-light-grey.svg`}
                        width="100"
                        height="100"
                        className="tooltip-user-tree not-select-text opacity"
                      />
                      <p className="tooltip-user-tree not-select-text">
                        No standard scenarios
                      </p>
                    </div>
                  )}
                <div>
                  <div>
                    {items.templatesTree?.sort(comparator).map((folder) => (
                      <Node2
                        node={folder}
                        key={folder.id}
                        isNeedRefreshAllTree={isNeedRefreshAllTree}
                        setIsNeedRefreshAllTree={setIsNeedRefreshAllTree}
                      />
                    ))}
                  </div>
                </div>
              </div>

              <div className="left-link-space">
                <Link to="/logout">
                  <button className="small-button red">LOGOUT</button>
                </Link>
                <Link to="account-info">
                  <button className="small-button deep-blue">USER INFO</button>
                </Link>
                {user?.role === "ADMIN" && (
                  <Link to="/users">
                    <button className="small-button deep-blue">USERS</button>
                  </Link>
                )}
              </div>

              <LargeButton
                cssStyle={"small-button deep-blue  collapse-expand-tree"}
                handler={(e) => handleViewMode(e)}
                id={"collapse-tree"}
                buttonText={"<< COLLAPSE SCENARIOS"}
              />
            </div>
          )}

          <div className="item graph">
            <div>
              {(scenarioSimulateID || templateSimulateID) &&
                !isChangedCurrentScenario && (
                  <h4>
                    {" "}
                    {simulatedScenarioName ? simulatedScenarioName : null}
                  </h4>
                )}
              {(scenarioSimulateID || templateSimulateID) &&
                isChangedCurrentScenario && (
                  <h4>
                    {" "}
                    {simulatedScenarioName ? simulatedScenarioName : null}{" "}
                    <span
                      className="editing-star"
                      title='The scenario has been changed. Press "Save" to save changes, or "Cancel" to revert.'
                    >
                      *
                    </span>
                  </h4>
                )}
              {errorMsg && (
                <span className="badge text-bg-danger">{errorMsg}</span>
              )}
              {statistic?.selectedProduct && <div>
                <h5>{statistic.selectedProduct} @ {statistic.selectedLocation}</h5>
              </div>}
              <table>
                <thead></thead>
                {(scenarioSimulateID || templateSimulateID) && !errorMsg && (
                  <SimulationResultsDataTable statistic={statistic} />
                )}
              </table>
            </div>
            <div>
              {isLoading && !plotData ? (
                <Loader loaderStyle={{ width: "100px" }}/>
              ) : (
                plotData &&
                !errorMsg &&
                (scenarioSimulateID || templateSimulateID) && (
                  <SimulationChart
                    userRole={user?.role}
                    viewMode={viewMode}
                    chartData={plotData}
                    maxChartValue={maxChartValue}
                  />
                )
              )}
            </div>
          </div>

          {(viewMode === "main-page-fullView" ||
            viewMode === "main-page-graphAndProps") && (
            <div className="item props">
              <div>
                {(scenarioSimulateID || templateSimulateID) &&
                  !errorMsg &&
                  user?.role === "CLIENT" && (
                    <PropertyPanel
                      simulatedId={scenarioSimulateID}
                      editMode={propertiesEditMode}
                    />
                  )}
              </div>

              {(scenarioSimulateID || templateSimulateID) &&
                !errorMsg &&
                user?.role === "CLIENT" && (
                  <div className="collapse-expand-props">
                    <button
                      className="small-button grey"
                      onClick={(e) => resetChanges(e)}
                      disabled={isResetChangesAndSaveButtonsDisabled}
                    >
                      RESET CHANGES
                    </button>
                    <button
                      className="small-button green"
                      onClick={(e) => saveChanges(e)}
                      disabled={isResetChangesAndSaveButtonsDisabled}
                    >
                      SAVE &amp; SIMULATE
                    </button>
                    <LargeButton
                      cssStyle={"small-button deep-blue"}
                      handler={(e) => handleViewMode(e)}
                      id={"collapse-props"}
                      buttonText={"COLLAPSE PROPERTIES >>"}
                    />
                  </div>
                )}
            </div>
          )}
        </div>

        {!(
          viewMode === "main-page-fullView" ||
          viewMode === "main-page-graphAndTree"
        ) && (
          <LargeButton
            cssStyle={"small-button deep-blue  collapse-expand-tree"}
            handler={(e) => handleViewMode(e)}
            id={"expand-tree"}
            buttonText={"EXPAND SCENARIOS >>"}
          />
        )}

        {!(
          viewMode === "main-page-fullView" ||
          viewMode === "main-page-graphAndProps"
        ) &&
          user?.role !== "ADMIN" && (
            <LargeButton
              cssStyle={"small-button deep-blue  collapse-expand-button"}
              handler={(e) => handleViewMode(e)}
              id={"expand-props"}
              buttonText={"<< EXPAND PROPERTIES"}
            />
          )}
      </div>
      <div>
        <ModalCreateNewFolder
          onHide={(e) => handleCloseCreateNewFolderWindow(e)}
          handleCreateNewFolder={(e) => handleCreateNewFolder(e)}
          folderName={(e) => handleNewFolderNameCreate(e)}
          isShowWindow={isShowCreateNewFolderWindow}
          title={CREATE_NEW_FOLDER_IN_ROOT_FOLDER_TITLE}
          setOnPressEnter={setOnPressEnterCreateModalNewFolder}
          isActiveCreateNewFolderButton={creationFolderName}
        />
      </div>
    </div>
  );
};

export default Main;
